import React, { useEffect } from 'react';

const LegalPageLayout = ({ title, children, lastUpdated }) => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div style={{ background: '#000000', minHeight: '100vh', color: '#ffffff', paddingTop: '100px', paddingBottom: '60px' }}>
      <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '0 5%' }}>
        <h1 style={{ 
          fontSize: 'clamp(2rem, 5vw, 3rem)', 
          fontWeight: 800, 
          marginBottom: '1rem',
          letterSpacing: '-0.02em',
          color: '#ffffff'
        }}>
          {title}
        </h1>
        {lastUpdated && (
          <p style={{ color: '#888888', fontSize: '0.9rem', marginBottom: '3rem', fontWeight: 600 }}>
            Last updated: {lastUpdated}
          </p>
        )}
        
        <div style={{ 
          lineHeight: 1.8, 
          color: '#bbbbbb',
          fontSize: '1.05rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem'
        }} className="legal-content">
          {children}
        </div>
      </div>
      <style>{`
        .legal-content h2 {
          color: #ffffff;
          font-size: 1.4rem;
          margin-top: 2rem;
          margin-bottom: 0.5rem;
          font-weight: 700;
        }
        .legal-content p {
          margin: 0;
        }
        .legal-content ul {
          margin: 0;
          padding-left: 1.5rem;
        }
        .legal-content li {
          margin-bottom: 0.5rem;
        }
        .legal-content strong {
          color: #ffffff;
          font-weight: 600;
        }
        .legal-content a {
          color: #00E599;
          text-decoration: none;
        }
        .legal-content a:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
};

export default LegalPageLayout;
